module.exports = __webpack_public_path__ + "static/media/16298.d7c0229a.png";